import React from 'react';

import { Alert, Box, Stack } from '@mui/material';

import type { PayloadValidationResult } from '~/utils/societePayloadBuilder/types';
import type { StatusCampaignPayloadBuilderState } from '~/utils/societePayloadBuilder/statusCampaign/types';

import LoadPayloadSection from '../LoadPayloadSection';
import { PAYLOAD_BUILDER_REQUIRED_FIELDS_SX } from '../FieldLabels';
import StatusClaimForm from './StatusClaimForm';
import StatusMatchForm from './StatusMatchForm';

interface StatusCampaignPayloadBuilderFormProps {
  state: StatusCampaignPayloadBuilderState;
  onChange: (next: StatusCampaignPayloadBuilderState) => void;
  loadJson: string;
  onLoadJsonChange: (value: string) => void;
  loadError: string | null;
  validation: PayloadValidationResult;
  loadCollapseKey?: number;
  onLoadPayload: () => void;
  onClearLoad: () => void;
  onUploadFile: (file: File) => void;
}

export default function StatusCampaignPayloadBuilderForm({
  state,
  onChange,
  loadJson,
  onLoadJsonChange,
  loadError,
  validation,
  loadCollapseKey,
  onLoadPayload,
  onClearLoad,
  onUploadFile,
}: StatusCampaignPayloadBuilderFormProps) {
  return (
    <Stack spacing={2}>
      <LoadPayloadSection
        loadJson={loadJson}
        loadError={loadError}
        collapseKey={loadCollapseKey}
        onLoadJsonChange={onLoadJsonChange}
        onLoadPayload={onLoadPayload}
        onClearLoad={onClearLoad}
        onUploadFile={onUploadFile}
      />

      {!validation.isValid ? (
        <Alert severity="warning">
          <Box component="ul" sx={{ my: 0, pl: 2.5 }}>
            {validation.errors.map((error) => (
              <li key={error}>{error}</li>
            ))}
          </Box>
        </Alert>
      ) : null}

      <Box sx={PAYLOAD_BUILDER_REQUIRED_FIELDS_SX}>
        {state.mode === 'statusMatch' ? (
          <StatusMatchForm state={state} onChange={onChange} />
        ) : (
          <StatusClaimForm state={state} onChange={onChange} />
        )}
      </Box>
    </Stack>
  );
}
